import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    copyUrl: 'Copy sharing link',
    copyUrlSuccess: 'The sharing link has been copied to your clipboard',
    description:
      'Your client will be able to view your invoice from a link or send it manually as a PDF.',
    downloadPdf: 'Download PDF',
    title: 'Sharing method',
  },
  fr: {
    copyUrl: 'Copier le lien de partage',
    copyUrlSuccess: 'Le lien de partage a été copié dans votre presse-papier',
    description:
      'Votre client pourra consulter la facture depuis un lien ou envoyez-la manuellement en PDF.',
    downloadPdf: 'Télécharger la facture PDF',
    title: 'Mode de partage',
  },
});
